import React, {useContext, useEffect, useRef, useState} from 'react';
import {
    Dimensions,
    FlatList,
    Modal,
    Pressable,
    ScrollView,
    Text,
    TextInput,
    TouchableOpacity,
    useWindowDimensions,
    View
} from 'react-native';
import Icon from 'react-native-vector-icons/MaterialCommunityIcons';
import IonIcons from 'react-native-vector-icons/Ionicons';
import {useNavigation} from '@react-navigation/native';
import {SystemContext} from './SystemContext';
import {VipCardContext} from './VipCardContext';
import {getAccessToken} from "../helpers/storage";
import {Checkbox} from "react-native-paper";
import {useTranslation} from 'react-i18next';
import '../../i18n';
import {TourContext} from "./TourContext";
import CustomTooltip from "./CustomTooltip";
import {OrdersContext} from "./OrdersContext";
import {ModalKeyboardAvoider} from '../components/KeyboardAware';
import {useThemedStyles} from './useThemedStyles';
import {refreshAppBadge, subscribeAppBadgeCounts} from './appBadge';
import {useTheme} from './ThemeContext';
import ChatHeaderButton from '../components/chat/ChatHeaderButton';

const generateCardId = () => {
    return Math.floor(Math.random() * (999 - 100 + 1) + 100) + "-" + Math.floor(Math.random() * (999 - 100 + 1) + 100);
};

const CustomHeader = (props) => {
    const { t } = useTranslation();
    const { width } = useWindowDimensions();
    const { theme } = useTheme();
    const styles = useThemedStyles(buildStyles);
    const navigation = useNavigation();
    const [vipMenuVisible, setVipMenuVisible] = useState(false);
    const [addVipModalVisible, setAddVipModalVisible] = useState(false);
    const [filterText, setFilterText] = useState('');
    const { vipCards, fetchSystemData, admins } = useContext(SystemContext);
    const { selectedVipCard, selectVipCard, removeVipCard, selectEmployee, selectedEmployee, } = useContext(VipCardContext);
    const { startTour, nextStep, endTour, currentStep, tourCompleted } = useContext(TourContext);
    const iconRef = useRef(null);
    const inputRef = useRef(null);
    const [menuPosition, setMenuPosition] = useState({ top: 0, left: 0 });
    const [cardId, setCardId] = useState(generateCardId());
    const [lastName, setLastName] = useState('');
    const [firstName, setFirstName] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [email, setEmail] = useState('');
    const [discountPercentage, setDiscountPercentage] = useState('');
    const [creditPercentage, setCreditPercentage] = useState('');
    const [searchInputValue, setSearchInputValue] = useState(props.searchString);
    const [serviceFee, setServiceFee] = useState(false);
    const [isCardInputVisible, setIsCardInputVisible] = useState(false);
    // Add this state variable
    const [isVipSelected, setIsVipSelected] = useState(true);
    const [pendingOrders, setPendingOrders] = useState([])
    const { orders } = useContext(OrdersContext);
    const isCompactHeader = width < 768;
    const isSearchFocusedRef = useRef(false);

    useEffect(() => {
        setSearchInputValue(props.searchString || '');
    }, [props.searchString]);


    // Add these functions to handle button presses
    const handleVipPress = () => setIsVipSelected(true);
    const handleEmployeesPress = () => setIsVipSelected(false);

    const openVipMenu = () => {
        if (iconRef.current) {
            // Avoid logging the entire iconRef.current object which contains circular references
            console.log("openvip menu opened");
            iconRef.current.measure((fx, fy, width, height, px, py) => {
                setMenuPosition({ top: py, left: px - 230 });
                setVipMenuVisible(true);
            });
        }
    };

    useEffect(() => {
        if (orders) {
            setPendingOrders(orders.filter(order => (order.status === "pending" && !order.storno)) || []);
        }
    }, [orders])

    // The header bell opens the notification inbox, so its badge must count what that
    // screen actually holds: the pinned pending orders AND the unread notifications.
    // The count comes from the shared appBadge store (the same fetch that paints the
    // OS app-icon badge), so this costs no extra request.
    const [unreadNotifications, setUnreadNotifications] = useState(0);

    useEffect(() => {
        const unsubscribe = subscribeAppBadgeCounts((counts) => {
            setUnreadNotifications(Number(counts?.notifications) || 0);
        });
        refreshAppBadge();

        return unsubscribe;
    }, []);

    const notificationBadgeCount = pendingOrders.length + unreadNotifications;

    const formatPhoneNumber = (text) => {

        const cleaned = ('' + text).replace(/\D/g, '');
        console.log(cleaned)
        const match = cleaned.match(/^(\d{4})(\d{3})(\d{4})$/);
        if (match) {
            return `+${match[1]}-${match[2]}-${match[3]}`;
        }
        return text;
    };

    const handleVipSelect = (vipCard) => {
        if (selectedVipCard && selectedVipCard._id === vipCard._id) {
            removeVipCard();
        } else {
            selectVipCard(vipCard);
        }
        setVipMenuVisible(false);
    };
    const handleEmployeeSelect = (employee) => {
        if (selectedEmployee && selectedEmployee._id === selectedEmployee._id) {
            //removeEmployee();
        } else {
            selectEmployee(employee);
        }
        setVipMenuVisible(false);
    };

    const renderEmployeeItem = ({ item }) => {
        const isSelected = selectedEmployee && selectedEmployee._id === item._id;
        const fullName = `${item.name.first} ${item.name.last}`;
        const email = item.email;
        const lastLogin = new Date(item.lastLogin).toLocaleString();

        return (
            <TouchableOpacity
                onPress={() => handleEmployeeSelect(item)}
                style={[styles.vipItem, isSelected && styles.selectedVipItem]}
            >
                <IonIcons name="person-circle-outline" size={35} style={styles.vipIcon} />
                <View style={styles.vipInfo}>
                    <Text style={styles.vipName}>{fullName}</Text>
                    <Text style={styles.vipBalance}>{email}</Text>
                    <Text style={styles.vipDiscount}>{t('last_login_label', { time: lastLogin })}</Text>
                </View>
                <IonIcons name="information-circle-outline" size={25} style={{
                    marginLeft: 12,
                    padding: 8,
                    backgroundColor: '#959595',
                    borderRadius: 6,
                    color: '#c6c6c6'
                }} onPress={() => { console.log("Employee info:", { id: item._id, name: `${item.name.first} ${item.name.last}`, email: item.email }) }} />
                {/*color: '#007AFF'}} onPress={() => { setVipMenuVisible(false); navigation.navigate('EmployeeDetailScreen', { employee: item }); }} />*/}
            </TouchableOpacity>
        );
    };

    const renderVipItem = ({ item }) => {
        const isSelected = selectedVipCard && selectedVipCard._id === item._id;
        const formattedBalance = Number(item.balance || 0).toLocaleString('hu-HU') + ' Ft';
        const discountText = item.discountAmount ? `${item.discountAmount}% ${t("discount_title")}` : '';

        return (
            <TouchableOpacity
                onPress={() => handleVipSelect(item)}
                style={[styles.vipItem, isSelected && styles.selectedVipItem]}
            >
                <IonIcons name="person-circle-outline" size={35} style={styles.vipIcon} />
                <View style={styles.vipInfo}>
                    <Text style={styles.vipName}>
                        {item.user.name.first && item.user.name.last
                            ? `${item.user.name.first} ${item.user.name.last}`
                            : item.cardId}
                    </Text>
                    <Text style={styles.vipBalance}>{t("balance")}: {formattedBalance}</Text>
                    <Text style={styles.vipDiscount}>{discountText}</Text>
                </View>
                <IonIcons name="information-circle-outline" size={25} style={{
                    marginLeft: 12,
                    padding: 8,
                    backgroundColor: '#add1ff',
                    borderRadius: 6,
                    color: '#007AFF'
                }} onPress={() => { setVipMenuVisible(false); navigation.navigate('VipUserDetailScreen', { vipCard: item }); }} />
            </TouchableOpacity>
        );
    };

    const filteredVipCards = vipCards.filter((card) => {
        const fullName = `${card.user.name.first} ${card.user.name.last}`.toLowerCase();
        return fullName.includes(filterText.toLowerCase());
    });

    const filteredAdmins = admins.filter((admin) => {
        const fullName = `${admin.name.first} ${admin.name.last}`.toLowerCase();
        return fullName.includes(filterText.toLowerCase());
    });

    const sortedVipCards = selectedVipCard
        ? [selectedVipCard, ...filteredVipCards.filter((card) => card._id !== selectedVipCard._id)]
        : filteredVipCards;

    const handleSave = async () => {
        const token = await getAccessToken();
        const vipUserData = {
            cardId: cardId,
            startAmount: 0,
            creditPercentage: Number(creditPercentage || 0),
            discountAmount: Number(discountPercentage || 0),
            enableServiceFee: serviceFee || true,
            user: {
                name: {
                    first: firstName,
                    last: lastName,
                },
                phone: phoneNumber,
            },
        };

        try {
            const response = await fetch('https://api.happysolutions.hu/api/vipcard/register', {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token },
                body: JSON.stringify(vipUserData),
            });

            if (!response.ok) {
                throw new Error('Failed to save VIP user');
            }

            const data = await response.json();
            await fetchSystemData({ force: true });
            setAddVipModalVisible(false);
        } catch (error) {
            console.error('Error saving VIP user:', error);
        }
    };

    const toggleCardInputVisibility = () => {
        setIsCardInputVisible(!isCardInputVisible);
        if (!isCardInputVisible) {
            globalThis.setTimeout(() => {
                inputRef.current.focus();
            }, 100);
        }
    };

    const handlePhoneNumberChange = (text) => {
        const phoneNumberPattern = /^\+\d{0,15}$/;
        if (text === '' || text === '+') {
            setPhoneNumber('+')
        } else if (phoneNumberPattern.test(text)) {
            setPhoneNumber(text)
        } else if (/^\d+$/.test(text)) {
            setPhoneNumber(`+${text}`)
        }
    };

    const resetSearchInput = () => {
        setSearchInputValue('');
        props.setSearchString('');
        props.setSelectedCategory(null);
    };

    const handleSearchInputPress = () => {
        if (isSearchFocusedRef.current && searchInputValue?.length > 0) {
            resetSearchInput();
        }
    };

    return (
        <View style={[styles.header]}>
            <CustomTooltip
                isVisible={currentStep === 0 && !tourCompleted}
                onNext={() => {
                    nextStep()
                }}
                topMargin={50}
                placement="top"
                module={"default"}
                onClose={endTour}
                wrapped={(<TouchableOpacity onPress={() => navigation.navigate('TicketEntry')} activeOpacity={0.9} hitSlop={12} style={[styles.iconTouchable, isCompactHeader && styles.iconTouchableCompact]}>
                    <Icon name="ticket" size={isCompactHeader ? 28 : 30} style={styles.icon} />
                </TouchableOpacity>
                )}
            />


            <View style={[styles.searchContainer, isCompactHeader && styles.searchContainerCompact, { margin: 0, padding: 0 }]}>
                <TextInput
                    ref={inputRef}
                    style={[styles.searchInput, isCompactHeader && styles.searchInputCompact, { color: searchInputValue.length > 1 ? theme.colors.text : theme.colors.subText, borderColor: 'transparent', borderRadius: 25, width: '100%', paddingLeft: 15 }]}
                    placeholder={t('search_placeholder')}
                    placeholderTextColor={theme.colors.placeholder}
                    value={searchInputValue}
                    textContentType="none" // Disables suggestions on Android
                    autoCorrect={false}
                    onPressIn={handleSearchInputPress}
                    onTouchStart={handleSearchInputPress}
                    onChangeText={(text) => {
                        setSearchInputValue(text)
                        props.setSearchString(text)
                    }}
                    onFocus={() => {
                        isSearchFocusedRef.current = true;
                        resetSearchInput();
                    }}
                    onBlur={() => {
                        isSearchFocusedRef.current = false;
                    }}
                />
            </View>

            <TouchableOpacity ref={iconRef} activeOpacity={0.6} hitSlop={12} style={[styles.iconTouchable, isCompactHeader && styles.iconTouchableCompact]} onPress={() => {
                nextStep();
                startTour()
            }}>
                <IonIcons
                    name="help-circle-outline"
                    size={isCompactHeader ? 28 : 30}
                    style={[styles.icon]}
                />
            </TouchableOpacity>
            <CustomTooltip
                isVisible={currentStep === 1}
                onNext={() => {
                    nextStep();
                }}
                placement="top"
                module={"default"}
                topMargin={50}
                parentStyle={{ alignSelf: 'center' }}
                onClose={endTour}
                wrapped={(<TouchableOpacity ref={iconRef} activeOpacity={0.6} hitSlop={12} style={[styles.iconTouchable, isCompactHeader && styles.iconTouchableCompact]} onPress={openVipMenu}>
                    <IonIcons
                        name="people-circle-outline"
                        size={isCompactHeader ? 28 : 30}
                        style={[styles.icon, selectedVipCard && { color: '#F1B44C' }]}
                    />
                </TouchableOpacity>
                )}
            />


            {/*vipModal*/}
            <Modal
                transparent
                visible={vipMenuVisible}
                animationType="fade"
                onRequestClose={() => setVipMenuVisible(false)}
            >
                <Pressable style={styles.modalOverlay} onPress={() => setVipMenuVisible(false)} />
                <View style={[styles.vipMenuContent, { top: menuPosition.top, left: menuPosition.left },
                !isVipSelected && { paddingBottom: 30, }]}>
                    <View style={styles.toggleContainer}>

                        <TouchableOpacity
                            style={[styles.toggleButton, isVipSelected && styles.selectedToggleButton]}
                            onPress={handleVipPress}
                        >
                            <Text style={[styles.toggleButtonText, !isVipSelected && { color: "black" }]}>VIP</Text>
                        </TouchableOpacity>
                        <TouchableOpacity
                            style={[styles.toggleButton, !isVipSelected && styles.selectedToggleButton]}
                            onPress={handleEmployeesPress}
                        >
                            <Text style={[styles.toggleButtonText, isVipSelected && { color: "black" }]}>{t("employees")}</Text>
                        </TouchableOpacity>
                    </View>
                    <TextInput
                        style={styles.filterInput}
                        placeholder={t('search_placeholder')}
                        value={filterText}
                        onChangeText={setFilterText}
                        onFocus={() => setFilterText('')}
                    />
                    <FlatList
                        data={isVipSelected ? sortedVipCards : filteredAdmins}
                        renderItem={isVipSelected ? renderVipItem : renderEmployeeItem}
                        keyExtractor={(item) => item._id}
                        style={styles.vipList}
                        ListEmptyComponent={isVipSelected ?
                            <View style={styles.emptyListContainer}>
                                <Text style={styles.emptyListText}>{t('no_vip_cards')}</Text>
                            </View> : null
                        }
                    />
                    {isVipSelected && (<TouchableOpacity
                        style={styles.modalOption}
                        onPress={() => {
                            setVipMenuVisible(false);
                            navigation.navigate('VipUserScreen');
                        }}
                    >
                        <Text>{t('all_vip')}</Text>
                    </TouchableOpacity>)}

                    {isVipSelected && (<TouchableOpacity
                        style={[styles.modalOption, { backgroundColor: 'orange' }]}
                        onPress={() => {
                            setVipMenuVisible(false);
                            setAddVipModalVisible(true);
                        }}
                    >
                        <Text style={{ color: 'white', fontWeight: "bold" }}>{t('add_vip')}</Text>
                    </TouchableOpacity>)}

                </View>
            </Modal>

            <Modal
                transparent
                visible={addVipModalVisible}
                animationType="slide"
                onRequestClose={() => setAddVipModalVisible(false)}
            >
                <ModalKeyboardAvoider style={styles.modalOverlay} justify="center">
                    <View style={styles.addVipModalContent}>
                        <ScrollView contentContainerStyle={styles.container} keyboardShouldPersistTaps="handled">
                            <Text style={styles.label}>{t('card')}</Text>
                            <View style={{ flexDirection: "row" }}>
                                <TouchableOpacity onPress={toggleCardInputVisibility} activeOpacity={0.6}>
                                    <IonIcons name="qr-code-outline" size={30} style={styles.icon} />
                                </TouchableOpacity>

                                {isCardInputVisible && (
                                    <>
                                        <TextInput
                                            ref={inputRef}
                                            style={styles.input}
                                            value={cardId}
                                            onChangeText={setCardId}
                                            onFocus={(e) => { e.target.value = '' }}
                                        />
                                    </>
                                )}
                            </View>

                            <View style={styles.row}>
                                <View style={styles.halfInputContainer}>
                                    <Text style={styles.label}>{t('last_name')}</Text>
                                    <TextInput style={styles.input} value={lastName} onChangeText={setLastName} />
                                </View>
                                <View style={styles.halfInputContainer}>
                                    <Text style={styles.label}>{t('first_name')}</Text>
                                    <TextInput style={styles.input} value={firstName} onChangeText={setFirstName} />
                                </View>
                            </View>

                            <Text style={styles.label}>{t('phone_number')}</Text>
                            <TextInput style={styles.input} value={phoneNumber} onChangeText={handlePhoneNumberChange} keyboardType="phone-pad" />

                            <Text style={styles.label}>{t('email')}</Text>
                            <TextInput style={styles.input} value={email} onChangeText={setEmail} keyboardType="email-address" />


                            <View style={styles.row}>
                                <View style={styles.halfInputContainer}>
                                    <Text style={styles.label}>{t('discount')}</Text>
                                    <View style={styles.percentageInputContainer}>
                                        <TextInput
                                            style={[styles.input, styles.percentageInput]}
                                            value={discountPercentage}
                                            onChangeText={(text) => {
                                                const numericValue = text.replace(/[^0-9]/g, ''); // Allow only numbers
                                                if (numericValue === '' || (parseInt(numericValue, 10) <= 100)) {
                                                    setDiscountPercentage(numericValue);
                                                }
                                            }}
                                            keyboardType="numeric"
                                        />
                                        <Text style={styles.percentageSymbol}>%</Text>
                                    </View>
                                </View>

                                <View style={styles.halfInputContainer}>
                                    <Text style={styles.label}>{t('credit')}</Text>
                                    <TextInput
                                        style={styles.input}
                                        value={creditPercentage}
                                        onChangeText={(text) => {
                                            const numericValue = text.replace(/[^0-9]/g, ''); // Allow only numbers
                                            setCreditPercentage(numericValue);
                                        }}
                                        keyboardType="numeric"
                                    />
                                </View>
                            </View>

                            <View style={styles.checkboxContainer}>
                                <Checkbox
                                    status={serviceFee ? 'checked' : 'unchecked'}
                                    onPress={() => setServiceFee(!serviceFee)}
                                />
                                <Text style={styles.checkboxLabel}>{t('service_fee')}</Text>
                            </View>

                            <View style={styles.buttonContainer}>
                                <TouchableOpacity style={[styles.button, styles.cancelButton]} onPress={() => setAddVipModalVisible(false)}>
                                    <Text style={styles.buttonText}>{t('cancel')}</Text>
                                </TouchableOpacity>
                                <TouchableOpacity style={[styles.button, styles.saveButton]} onPress={handleSave}>
                                    <Text style={styles.buttonText}>{t('save')}</Text>
                                </TouchableOpacity>
                            </View>
                        </ScrollView>
                    </View>
                </ModalKeyboardAvoider>
            </Modal>
            {/* Team Chat (unread badge) — renders nothing when chat is excluded. */}
            <ChatHeaderButton
                size={isCompactHeader ? 26 : 28}
                color={theme.colors.text}
                style={[styles.iconTouchable, isCompactHeader && styles.iconTouchableCompact]}
            />
            <CustomTooltip
                isVisible={currentStep === 2}
                onNext={() => {
                    nextStep();
                }}
                topMargin={50}
                placement="top"
                module={"default"}
                onClose={endTour}
                wrapped={(
                    <TouchableOpacity
                        activeOpacity={0.6}
                        hitSlop={12}
                        style={[styles.iconTouchable, isCompactHeader && styles.iconTouchableCompact]}
                        onPress={() => navigation.navigate('NotificationsScreen')}
                    >
                        <View style={{ position: 'relative' }}>
                            <IonIcons name="notifications" size={isCompactHeader ? 28 : 30} style={styles.icon} />
                            {notificationBadgeCount > 0 && (
                                <View
                                    style={{
                                        position: 'absolute',
                                        top: -4,
                                        right: -2,
                                        backgroundColor: 'red',
                                        borderRadius: 10,
                                        minWidth: 20,
                                        paddingHorizontal: 4,
                                        height: 20,
                                        justifyContent: 'center',
                                        alignItems: 'center'
                                    }}
                                >
                                    <Text style={{
                                        color: 'white',
                                        fontSize: 12,
                                        fontWeight: 'bold'
                                    }}>
                                        {notificationBadgeCount > 99 ? '99+' : notificationBadgeCount}
                                    </Text>
                                </View>
                            )}
                        </View>
                    </TouchableOpacity>
                )}
            />

        </View>
    );
};

const buildStyles = (theme) => ({
    header: {
        height: 60,
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingHorizontal: 10,
        backgroundColor: theme.colors.background,
    },
    icon: {
        paddingHorizontal: 10,
        color: theme.colors.text,
    },
    iconTouchable: {
        minWidth: 48,
        minHeight: 48,
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: 24,
    },
    iconTouchableCompact: {
        minWidth: 52,
        minHeight: 52,
    },
    searchContainer: {
        flex: 1,
        flexDirection: 'row',
        alignItems: 'center',
        borderColor: theme.colors.border,
        backgroundColor: theme.colors.inputBackground,
        borderWidth: 1,
        borderRadius: 20,
        paddingHorizontal: 15,
        marginHorizontal: 15,
    },
    searchContainerCompact: {
        minHeight: 52,
        borderRadius: 24,
        paddingHorizontal: 12,
        marginHorizontal: 10,
    },
    searchIcon: {
        marginRight: 10,
        color: theme.colors.subText,
    },
    searchInput: {
        flex: 1,
        height: 40,
    },
    searchInputCompact: {
        height: 44,
        fontSize: 16,
    },
    modalOverlay: {
        flex: 1,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        justifyContent: 'center',
        alignItems: 'center',
    },
    vipMenuContent: {
        position: 'absolute',
        width: 300,
        backgroundColor: theme.colors.card,
        borderRadius: 10,
        padding: 8,
        maxHeight: "75svh",
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.3,
        shadowRadius: 4,
        elevation: 5,
    },
    vipList: {
        maxHeight: 320,
        minHeight: 100,
    },
    filterInput: {
        padding: 8,
        borderColor: theme.colors.border,
        color: theme.colors.text,
        borderWidth: 1,
        borderRadius: 5,
        marginBottom: 2,
    },
    vipItem: {
        paddingVertical: 4,
        paddingHorizontal: 12,
        flexDirection: 'row',
        alignItems: 'center',
        backgroundColor: theme.colors.card,
        borderRadius: 10,
        marginVertical: 1,
    },
    selectedVipItem: {
        backgroundColor: '#F1B44C',
    },
    vipIcon: {
        marginRight: 12,
        color: '#F76C6C',
    },
    vipInfo: {
        flex: 1,
    },
    vipName: {
        fontWeight: 'bold',
        fontSize: 16,
        color: theme.colors.text,
    },
    vipBalance: {
        fontSize: 14,
        color: theme.colors.subText,
    },
    vipDiscount: {
        fontSize: 14,
        color: '#28a745',
        fontWeight: 'bold',
    },
    emptyListContainer: {
        padding: 20,
        alignItems: 'center',
        justifyContent: 'center',
    },
    emptyListText: {
        fontSize: 16,
        color: theme.colors.subText,
        textAlign: 'center',
    },
    percentageInputContainer: {
        flexDirection: 'row',
        alignItems: 'center',
        position: 'relative',
    },
    percentageInput: {
        flex: 1,
    },
    percentageSymbol: {
        position: 'absolute',
        right: 8,
        fontSize: 16,
        top: 8,
        fontWeight: 'bold',
        color: theme.colors.subText,
    },
    button: {
        flex: 1,
        padding: 18,
        alignItems: 'center',
        borderRadius: 5,
    },
    toggleContainer: {
        flexDirection: 'row',
        justifyContent: 'center',
        marginBottom: 10,
    },
    toggleButton: {
        flex: 1,
        padding: 10,
        alignItems: 'center',
        borderWidth: 1,
        borderColor: theme.colors.border,
        borderRadius: 5,
        marginHorizontal: 5,
    },
    selectedToggleButton: {
        backgroundColor: '#F1B34B',
    },
    toggleButtonText: {
        color: '#fff',
        fontWeight: 'bold',
    },
    cancelButton: {
        backgroundColor: 'grey',
        marginRight: 10,
    },
    saveButton: {
        backgroundColor: '#F1B34B',
    },
    buttonText: {
        color: 'white',
        fontSize: 16,
    },
    modalOption: {
        paddingHorizontal: 15,
        paddingVertical: 12,
        alignItems: 'center',
        borderTopWidth: 1,
        borderTopColor: theme.colors.border,
    },
    addVipModalContent: {
        width: Dimensions.get('window').width > 600 ? '37%' : '90%',
        backgroundColor: theme.colors.card,
        borderRadius: 10,
        padding: 20,
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.3,
        shadowRadius: 4,
        elevation: 5,
    },
    container: {
        padding: 20,
    },
    label: {
        fontSize: 16,
        marginBottom: 3,
        color: theme.colors.text,
    },
    input: {
        borderWidth: 1,
        borderColor: theme.colors.border,
        color: theme.colors.text,
        borderRadius: 5,
        padding: 10,
        marginBottom: 10,
    },
    row: {
        flexDirection: 'row',
        justifyContent: 'space-between',
    },
    halfInputContainer: {
        flex: 1,
        marginRight: 10,
    },
    checkboxContainer: {
        flexDirection: 'row',
        alignItems: 'center',
        marginBottom: 10,
    },
    checkboxLabel: {
        marginLeft: 8,
        color: theme.colors.text,
    },
    buttonContainer: {
        flexDirection: 'row',
        justifyContent: 'space-between',
    },
});

export default React.memo(CustomHeader);
